const initialState = {
  isData: false,
  conciliacion: [],
  selConciliacion: null,
  pagination: null,
};

const initialConciliacionState = {
  selConciliacion: null,
};

export const conciliacion = (state = initialState, action) => {
  switch (action.type) {
    case 'setConciliacion': {
      if (action.value.status === 200) {
        const stateData = {
          conciliacion: action.value.data,
          isData: true,
          pagination: action.value.pagination,
        };
        return { ...state, ...stateData };
      }
      return initialState;
    }
    case 'setConciliacionInit': {
      return initialState;
    }
    case 'setSelConciliacion': {
      const obj = {
        ...action.value,
      };

      const stateData = { selConciliacion: obj };

      return { ...state, ...stateData };
    }
    case 'setSelConciliacionInit': {
      return { ...state, ...initialConciliacionState };
    }
    default:
      return state;
  }
};
